var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.928,
    height: 18.928,
    viewBox: "0 0 18.928 18.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M13.013,0h-7.1A5.915,5.915,0,0,0,0,5.915v7.1a5.915,5.915,0,0,0,5.915,5.915h7.1a5.915,5.915,0,0,0,5.915-5.915v-7.1A5.915,5.915,0,0,0,13.013,0Zm4.14,13.013a4.145,4.145,0,0,1-4.14,4.14h-7.1a4.145,4.145,0,0,1-4.14-4.14v-7.1a4.145,4.145,0,0,1,4.14-4.14h7.1a4.145,4.145,0,0,1,4.14,4.14Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    "data-name": "Path 9516",
    d: "M8.732,4a4.732,4.732,0,1,0,4.732,4.732A4.732,4.732,0,0,0,8.732,4Zm0,7.689a2.957,2.957,0,1,1,2.957-2.957A2.961,2.961,0,0,1,8.732,11.689Z",
    transform: "translate(0.732 0.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2832",
    "data-name": "Ellipse 2832",
    cx: 0.631,
    cy: 0.631,
    rx: 0.631,
    ry: 0.631,
    transform: "translate(13.92 3.746)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.7a9e4c5cb3ce0323e4513a450c46b879.svg";
export { ForwardRef as ReactComponent };